/* unplugin-vue-components disabled */import __unplugin_components_6 from '~icons/ep/close';
import { ElIcon as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_4 from '~icons/ep/check';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/zpw/Documents/hero/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("配置");
import UTable from '@ultra/share/components/UTable/index.vue';
import ConfPagesDialog from './modules/confPagesDialog.vue';
import usePagesGetDataTable from './modules/usePagesGetDataTable';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const confPagesDialogRef = ref();
    const {
      filter,
      columns,
      tableData,
      tableLoading,
      getTableData
    } = usePagesGetDataTable();
    // 搜索
    const getPageConfListSearch = async () => {
      await getTableData();
      if (filter.value.cid) {
        tableData.value.filter(item => item.cid === filter.value.cid);
      }
    };
    const handleClick = async data => {
      confPagesDialogRef.value.show({
        data,
        gid: gameInfo.value.Id
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_GameChannelSelect = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_i_ep_Check = __unplugin_components_4;
      const _component_el_icon = __unplugin_components_5;
      const _component_i_ep_Close = __unplugin_components_6;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "所属渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
            gid: _unref(gameInfo).Id,
            otherProps: {
              isGlobal: 1
            }
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "marginL20",
            type: "primary",
            onClick: getPageConfListSearch
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(UTable, {
        options: _unref(columns),
        data: _unref(tableData),
        loading: _unref(tableLoading)
      }, {
        help: _withCtx(({
          scope
        }) => [scope.row.conf[3].val === '1' ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))]),
        account: _withCtx(({
          scope
        }) => [scope.row.conf[1].val === '1' ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))]),
        user: _withCtx(({
          scope
        }) => [scope.row.conf[0].val === '1' ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))]),
        loginout: _withCtx(({
          scope
        }) => [scope.row.conf[2].val ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick(scope.row)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["options", "data", "loading"]), _createVNode(ConfPagesDialog, {
        ref_key: "confPagesDialogRef",
        ref: confPagesDialogRef,
        onSuccess: _unref(getTableData)
      }, null, 8, ["onSuccess"])], 64);
    };
  }
});